import "./App.css";
import WalletConnector from "./components/WalletConnector";
import Homepage from "./pages/Homepage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/wallet" element={<WalletConnector />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
